
import { getTphendlist, spotOrderList,spotcancelOrder, closeOrder, stockList, getTpmicrolist, spotBuy, getCoinInfo, spotSell } from '../service/getdata'
import {mapState,mapMutations} from 'vuex'
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

export default{
data(){
return{
msg: "",
show: false,
name: "",
type: 1,

open_type: 1,
value2: 1,
option2: [{
text:this.$t('市价'),
value: 1
},{
text: this.$t('限价'),
value: 2
}],
yxList: [], //左侧列表数据
timeout: null,
showLeftList: false, //左侧列表是否展示
listLoading: false,
number: "",
timerInfo: null,
coinInfo: {}, //买卖五档
shuliang: "", //开仓数量
price: "", //开仓价格
holdList: [], //持有列表
orderType: 0, //0委托,2持有 1历史
flag: ""
}
},
components:{
Toast,
XHeader
},
computed:{
...mapState(['url','token'])
},
mounted() {
this.$nextTick(()=>{
this.getCoinInfo()
})
},
created(){
this.SETTOKEN()

this.name = this.$route.query.name
this.open_type = this.$route.query.stype || 1
this.trade_type = this.$route.query.trade_type
this.flag = this.$route.query.flag
if(this.trade_type=='3'){
this.orderType=2
}

},
methods:{
...mapMutations(['GETRECENTBUY','SETTOKEN']),
goContract(type, trade_type, name, enter, code){
if(trade_type==1){
this.$router.push(`/pages/info?name=${!!name ? name : this.name}&type=${type}&trade_type=1&enter=${enter}`)
}else if(trade_type==2){
this.$router.push(`/pages/info?name=${!!name ? name : this.name}&type=${type}&trade_type=2&pid=${this.pid}&enter=${enter}`)
}else{
this.$router.push(`/pages/info?name=${!!name ? name : this.name}&type=${type}&trade_type=3&code=${!!name ? name : this.name}&nation=${this.flag}&enter=${enter}`)
}

},
back(){
if(this.$route.query.enter=='info'){
this.$router.go(-1)
}else{
this.$router.push('/pages/home/quotes')
}
},
closeOrder(id){
var that = this
this.$vux.confirm.show({
title: that.$t("提示"),
content:that.$t("确定执行平仓操作"),
cancelText:that.$t("取消"),
confirmText: that.$t("确定"),
onConfirm:function(){
that.$Loading()
closeOrder({token: that.token, id, trade_type: that.trade_type}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){

that.$vux.alert.show({
title: that.$t("提示"),
content: res.message,
buttonText: that.$t("确定"),
onHide:function(){
that.getYxOrderList(true)

}
})
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}else{
that.sendMsg(res.message)
}
}.bind(this),function(){
that.$Loading.close()
that.$router.push("/pages/relogin")
console.log("error")
})
}
})

},
getOrderList(isLoading){
var that = this
if(!!isLoading){
this.$Loading()
}
spotOrderList({token: this.token,status: this.orderType,trade_type: this.trade_type, flag: this.flag}).then(function(res){
var res = res.data;
if(!!isLoading){
that.$Loading.close()
}
if(res.status=='1'){
that.holdList = res.data || []
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
if(!!isLoading){
that.$Loading.close()
}
that.$router.push("/pages/relogin")
console.log("error")
})
},
goHistory(){
if(this.type==1){
this.$router.push('/pages/perpetualHistory')
}else{
this.$router.push('/pages/deliveryContractHistory')
}
},
trade(type){
if(!this.shuliang || this.shuliang=='' || this.shuliang=='0'){
this.sendMsg('请输入交易金额')
return
}
if(this.value2==2 && ( !this.price || this.price=='' || this.price=='0')){
this.sendMsg('请输入价格')
return
}

const that = this
this.$vux.confirm.show({
title: that.$t("提示"),
content:that.$t("确定执行该操作"),
cancelText:that.$t("取消"),
confirmText: that.$t("确定"),
onConfirm:function(){
that.confirmTrade(type)
}
})
},


confirmTrade(type){

var that = this
this.$Loading()
if(type==1){
spotBuy({token: this.token, type, symbol: this.name,  number: this.shuliang, price: this.price, ptype: this.value2,trade_type: this.trade_type, flag: this.flag}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.sendMsg(res.message)
that.getOrderList(true)
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
that.$Loading.close()

that.$router.push("/pages/relogin")
console.log("error")
})
}else{
spotSell({token: this.token, type, symbol: this.name,  number: this.shuliang, price: this.price, ptype: this.value2,trade_type: this.trade_type, flag: this.flag}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.sendMsg(res.message)
that.getOrderList(true)
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
that.$Loading.close()

that.$router.push("/pages/relogin")
console.log("error")
})
}

},
cancelOrder(id){
var that = this

this.$vux.confirm.show({
title: that.$t("提示"),
content:that.$t("确定执行撤单操作？"),
cancelText:that.$t("取消"),
confirmText: that.$t("确定"),
onConfirm:function(){
that.$Loading()
spotcancelOrder({token: that.token, id,trade_type: that.trade_type, flag: this.flag}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){

that.$vux.alert.show({
title: that.$t("提示"),
content: res.message,
buttonText: that.$t("确定"),
onHide:function(){
that.getOrderList(true)

}
})
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}else{
that.sendMsg(res.message)
}
}.bind(this),function(){
that.$Loading.close()
that.$router.push("/pages/relogin")
console.log("error")
})
}
})

},

getCoinInfo() { // 获取数据
clearInterval(this.timerInfo)
this.timerInfo = null
this.getIntervalCoin()
this.timerInfo = setInterval(() => {
this.getIntervalCoin()
}, 2000);
},


getIntervalCoin(){
const that = this
getCoinInfo({ token: this.token,symbol: this.name, type: this.open_type,trade_type: this.trade_type, flag: this.flag}).then(function(res){
var res = res.data;
if(res.status=='1'){
that.coinInfo = res.data
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}else{
that.sendMsg(res.message)
}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
this.getOrderList()
},

getYxList(){
var that = this
that.showLeftList = true
this.listLoading = true
this.timeout = setInterval(() => {
if(this.trade_type=='1'){
if(this.type==1){
getTphendlist({ token: that.token,trade_type: that.trade_type, flag: this.flag}).then(function(res){
var res = res.data;
that.listLoading = false
if(res.status=='1'){

that.yxList = res.data
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
}else{
getTpmicrolist({ token: that.token,trade_type: that.trade_type, flag: this.flag}).then(function(res){
var res = res.data;

that.listLoading = false
if(res.status=='1'){

that.yxList = res.data
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){

console.log("error")
})
}
}else if(this.trade_type==3){
stockList({token: that.token, lang: that.$route.query.nation, flag: this.flag}).then(function(res){
var res = res.data;
that.listLoading = false
that.yxList = res.data
}.bind(this),function(){
if(isLoading){

}
console.log("error")
})
}

}, 2000);
},

chooseCoin(name, flag){
this.showLeftList = false
this.name = name
this.flag = flag


},
onClose() {
clearInterval(this.timeout)
this.timeout = null
},
clearTimer() { //清楚定时器

clearInterval(this.timeout)
this.timeout = null
clearInterval(this.timerInfo)
this.timerInfo = null
},

sendMsg(content) {
this.msg = content;
this.show = true;
},
},
deactivated() {
this.clearTimer()
},
beforeDestroy() {
this.clearTimer()
},
}



// WEBPACK FOOTER //
// ./src/pages/spot.vue